// extracted by mini-css-extract-plugin
module.exports = {"container":"_1CR884sj9PAcULFO93FUbg"};